if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        // Modal open: block click-through to ADD TO BAG (sticky ATC sits above buybox stacking context)
        if (
          document.body.classList.contains('buybox-modal-scroll-lock') ||
          document.querySelector(
            '[data-engraving-modal]:not([hidden]), [data-size-guide-modal]:not([hidden]), [data-metal-guide-modal]:not([hidden])'
          )
        ) {
          return;
        }

        if (this.closest('[data-fbw-quick-add], .complementary-card-figma')) {
          // Frequently Bought With: never validate the main PDP buybox
        } else {
          if (window.ProductBuyboxFigma && typeof window.ProductBuyboxFigma.validateSizePickers === 'function') {
            const invalidSize = window.ProductBuyboxFigma.validateSizePickers(this.closest('.product') || document);
            if (invalidSize) {
              invalidSize.scrollIntoView({ behavior: 'smooth', block: 'center' });
              const face = invalidSize.querySelector('.product-buybox-figma__select-face');
              if (face) face.focus();
              this.handleErrorMessage('Please select a size before adding to cart.');
              return;
            }
          }

          if (window.ProductBuyboxFigma && typeof window.ProductBuyboxFigma.validateChainPickers === 'function') {
            const invalid = window.ProductBuyboxFigma.validateChainPickers(this.closest('.product') || document);
            if (invalid) {
              if (typeof window.ProductBuyboxFigma.closeAllSelectPanels === 'function') {
                window.ProductBuyboxFigma.closeAllSelectPanels();
              }
              invalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
              const kind = invalid.getAttribute('data-figma-chain-kind') || '';
              const msg =
                kind === 'size'
                  ? 'Lütfen zincir boyunuzu seçin'
                  : 'Lütfen zincir tipinizi seçin';
              this.handleErrorMessage(msg);
              const face = invalid.querySelector('.product-buybox-figma__select-face');
              if (face) {
                face.focus();
                if (face.click) face.click();
              }
              return;
            }
          }
        }

        this.handleErrorMessage();

        this.syncVariantIdFromDom();
        if (this.variantIdInput) this.variantIdInput.disabled = false;

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const isFbwAdd = Boolean(this.closest('[data-fbw-quick-add], .complementary-card-figma'));
        const root = isFbwAdd ? this : this.closest('.product') || document;
        const missingPriced =
          !isFbwAdd &&
          window.ProductBuyboxFigma &&
          typeof window.ProductBuyboxFigma.getMissingPricedChainOptions === 'function'
            ? window.ProductBuyboxFigma.getMissingPricedChainOptions(root)
            : [];

        // Don't block ATC when upgrade product isn't linked in Theme Editor —
        // cart still gets the main item + Chain Type property; fee line items skip.
        if (missingPriced.length && typeof console !== 'undefined' && console.warn) {
          console.warn(
            '[TheSwaf] Chain upgrade product not linked for: ' +
              missingPriced.join(', ') +
              '. Set Variant picker → Chain type upgrade product (or create handle chain-type-upgrade).'
          );
        }

        const formData = new FormData(this.form);
        const mainId = formData.get('id');
        const quantity = parseInt(formData.get('quantity') || '1', 10) || 1;
        const properties = {};
        formData.forEach((value, key) => {
          const match = key.match(/^properties\[(.+)\]$/);
          if (match && value) properties[match[1]] = value;
        });

        const pricedPreview =
          !isFbwAdd &&
          window.ProductBuyboxFigma &&
          typeof window.ProductBuyboxFigma.getChainAddonItems === 'function'
            ? window.ProductBuyboxFigma.getChainAddonItems(root, quantity)
            : [];
        const chainGroup =
          pricedPreview.length > 0
            ? 'cg-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8)
            : '';
        if (chainGroup) properties._chain_group = chainGroup;

        const linkedAddons =
          !isFbwAdd && chainGroup && window.ProductBuyboxFigma
            ? window.ProductBuyboxFigma.getChainAddonItems(root, quantity, chainGroup)
            : [];

        const items = [
          {
            id: Number(mainId),
            quantity: quantity,
            properties: properties,
          },
        ].concat(linkedAddons);

        const useMulti = linkedAddons.length > 0;
        let config;
        let body;

        if (useMulti) {
          config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          config.headers['Content-Type'] = 'application/json';
          const payload = { items: items };
          if (this.cart) {
            payload.sections = this.cart.getSectionsToRender().map((section) => section.id);
            payload.sections_url = window.location.pathname;
            this.cart.setActiveElement(document.activeElement);
          }
          body = JSON.stringify(payload);
        } else {
          config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];
          if (this.cart) {
            formData.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }
          body = formData;
        }
        config.body = body;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('wb-quick-view');
            const wbModel = this.closest('wb-modal');
            if(wbModel){
              wbModel?.close();
            }
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (!this.submitButton || !this.submitButtonText) return;
        const brandAddLabel = this.getAddToCartLabel();
        const resolveLabel = (raw) => {
          if (raw == null || raw === '') return null;
          // Never flash locale "Add to cart" over Figma "ADD TO BAG"
          if (
            raw === window.variantStrings?.addToCart ||
            String(raw).toLowerCase() === 'add to cart'
          ) {
            return brandAddLabel;
          }
          return raw;
        };

        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          const label = resolveLabel(text);
          if (label) this.submitButtonText.textContent = label;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = resolveLabel(text) || brandAddLabel;
        }
      }

      getAddToCartLabel() {
        if (
          this.submitButton?.classList.contains('product-buybox-figma__submit') ||
          this.closest('.product-page-figma')
        ) {
          return 'ADD TO BAG';
        }
        return window.variantStrings?.addToCart || 'Add to cart';
      }

      /** Keep hidden variant id in sync with confirmed option selections + selected-variant JSON. */
      syncVariantIdFromDom() {
        if (
          window.ProductBuyboxFigma &&
          typeof window.ProductBuyboxFigma.syncProductVariantIdFromSelections === 'function'
        ) {
          const matched = window.ProductBuyboxFigma.syncProductVariantIdFromSelections(
            this.closest('product-info') || this
          );
          if (matched?.id) return;
        }
        const root = this.closest('product-info') || this;
        const script =
          root.querySelector('variant-selects [data-selected-variant]') ||
          root.querySelector('color-swatch [data-selected-variant]') ||
          root.querySelector('[data-selected-variant]');
        if (!script) return;
        try {
          const variant = JSON.parse(script.textContent || 'null');
          if (variant?.id && this.variantIdInput) {
            this.variantIdInput.disabled = false;
            this.variantIdInput.value = String(variant.id);
          }
        } catch (_) {}
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}